var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BigNumber } from 'ethers';
import { provider as defaultProvider } from '../Fct/plugins/provider/provider';
export var DEFAULT_ADDRESS = '0xD4a0281cEeebA1CEeFB4eAbF63ca6A608E143Fdc';
var Config = /** @class */ (function () {
    function Config(_a) {
        var chainId = _a.chainId, account = _a.account, provider = _a.provider, signer = _a.signer;
        var _this = this;
        this.signer = undefined;
        this.setLibrary = function (_a) {
            var chainId = _a.chainId, account = _a.account, provider = _a.provider;
            _this.chainId = Number(chainId);
            _this.library = provider || defaultProvider[chainId];
            if (!_this.library && !defaultProvider[chainId]) {
                console.error('Provider not found');
            }
            if (account && _this.library) {
                _this._account = account;
                _this.signer = _this.library.getSigner(account);
            }
        };
        this.setChainId = function (_a) {
            var chainId = _a.chainId;
            _this.chainId = Number(chainId);
        };
        this.setAccount = function (_a) {
            var account = _a.account;
            _this._account = account;
        };
        this.getLastBlock = function () { return __awaiter(_this, void 0, void 0, function () {
            var blockNumber, block, blockTimestamp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.library.getBlockNumber()];
                    case 1:
                        blockNumber = _a.sent();
                        return [4 /*yield*/, this.library.getBlock(blockNumber)];
                    case 2:
                        block = _a.sent();
                        blockTimestamp = BigNumber.from(block.timestamp);
                        return [2 /*return*/, { blockNumber: blockNumber, blockTimestamp: blockTimestamp }];
                }
            });
        }); };
        this._account = account || DEFAULT_ADDRESS;
        this.chainId = Number(chainId);
        this.library = provider || defaultProvider[chainId];
        if (!this.library && !defaultProvider[chainId]) {
            console.error('Provider not found');
        }
        if (account && this.library) {
            this.signer = signer || this.library.getSigner(account);
        }
    }
    Object.defineProperty(Config.prototype, "account", {
        get: function () {
            return this._account;
        },
        enumerable: false,
        configurable: true
    });
    return Config;
}());
export { Config };
